module.exports = __webpack_public_path__ + "static/img/live-score-ico.2a725dc.png";